import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * Button — design-system wrapper around a native `<button>`.
 *
 * No CSS framework is used. Variants map to the `data-variant` attribute
 * on `.osd-button` defined in `_base.scss`. All other props are forwarded
 * to the underlying `<button>` (type, onClick, disabled, aria-*).
 *
 * @example
 *   <Button variant="primary" onClick={save}>Save</Button>
 *   <Button variant="danger" disabled>Delete</Button>
 */
export const Button = forwardRef(function Button({ variant = 'default', type = 'button', className, children, ...rest }, ref) {
    const classes = ['osd-button', className].filter(Boolean).join(' ');
    return (_jsx("button", { ref: ref, type: type, "data-variant": variant, className: classes, ...rest, children: children }));
});
//# sourceMappingURL=Button.js.map